import styled from 'styled-components';

export const PageTitleStyled = styled.h1`
  margin-right: 12px;
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
  color: ${(p) => p.theme.colors.blue.dark};
`;
